import * as React from 'react';
import { observer, inject } from "mobx-react";

// =====================================
// STORES
import { IArticleStore } from '../../store/ArticleStore';

// =====================================
// COMPONENTS
import OrderingArticles from './OrderingArticles';
import DetailsOrderingArticles from './DetailsOrderingArticles';

@inject((allStores: any) => ({
    articleStore: allStores.store.articleStore as IArticleStore
}))

@observer
export default class Articles extends React.Component<{ articleStore?: IArticleStore; match?: any }, any> {

    componentDidMount() {
        this.props.articleStore.init();
    }

    componentWillUnmount() {
        this.props.articleStore.reset();
    }

    render() {
        return (
            <div className="articles-container">
                {!this.props.articleStore.isArticleListVisible ?
                    <OrderingArticles
                        customerId={this.props.match?.params?.customerId}
                        orderId={this.props.match?.params?.orderId}
                        isEditOrder={this.props.match?.params?.isEditOrder} />
                    :
                    <DetailsOrderingArticles
                        customerId={this.props.match?.params?.customerId}
                        orderId={this.props.match?.params?.orderId}
                        isEditOrder={this.props.match?.params?.isEditOrder} />
                }
            </div>
        );
    }
}